import { connect } from 'react-redux';
import Waiver from './Waiver';
import { getWaiverDetails, saveWaiverDecision } from 'actions/broker/';

const mapStateToProps = (state) => {
  return {
    fetchingWaiverDetails: state.broker.fetchingWaiverDetails,
    waiverDetails: state.broker.waiverDetails
 };
};

const mapDispatchToProps = (dispatch) => ({
  getWaiverDetails(id) {
    dispatch(getWaiverDetails(id));
  },
  saveWaiverDecision(waiverDecision) {
    dispatch(saveWaiverDecision(waiverDecision));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Waiver);
